/** Optional for reports captured before weekend target selection was added. */
export interface StaffReportingCalendar {
  calendar_policy_version?: 1;
  include_weekends?: boolean;
  target_day_count?: number;
  target_dates?: string[];
  weekend_day_count?: number;
  target_weekday_counts?: number[];
  weekend_activity_included?: boolean;
  calendar_day_count: number;
}
export function staffTargetDays(context: StaffReportingCalendar): number {
  return context.target_day_count ?? context.calendar_day_count;
}
export function staffTargetDayLabel(context: StaffReportingCalendar): string {
  return context.include_weekends === false ? 'weekday target days' : 'calendar dates';
}
export function staffCalendarMatches(context: StaffReportingCalendar, search: {include_weekends?: boolean}): boolean {
  // Older APIs already include weekends. Exclusion must be explicitly acknowledged by the server.
  return search.include_weekends !== false || (context?.include_weekends === false && Number.isInteger(context.target_day_count) && context.weekend_activity_included === true);
}
export const STAFF_CALENDAR_UPDATE_MESSAGE = 'Weekend target settings require the updated reporting API. Upload the development reporting files and refresh.';
